import { useTranslation } from 'react-i18next';
import type { PromoCampaignsResponse } from '../../types/feed';
import './PromoCollabCard.css';

type Item = PromoCampaignsResponse['items'][number];

export function PromoCollabCard({ item }: { item: Item }) {
  const { t } = useTranslation();
  const save =
    item.discountPct ??
    (item.priceOriginal > 0
      ? Math.round(((item.priceOriginal - item.priceTotal) / item.priceOriginal) * 100)
      : 0);

  return (
    <div className="pcc" aria-label={item.title}>
      <div className="pcc-thumbs">
        {item.productA.imageUrl ? (
          <img src={item.productA.imageUrl} alt="" className="pcc-thumb" />
        ) : (
          <div className="pcc-thumb pcc-thumb--fallback" />
        )}
        {item.productB.imageUrl ? (
          <img src={item.productB.imageUrl} alt="" className="pcc-thumb" />
        ) : (
          <div className="pcc-thumb pcc-thumb--fallback" />
        )}
      </div>
      <div className="pcc-body">
        <span className="pcc-badge">{t('feed.promoBadge')}</span>
        <div className="pcc-title">{item.title}</div>
        <div className="pcc-price-row">
          <span className="pcc-price">{item.priceTotal.toLocaleString('ru-RU')} ₸</span>
          {item.priceOriginal > item.priceTotal && (
            <span className="pcc-orig">{item.priceOriginal.toLocaleString('ru-RU')} ₸</span>
          )}
          {save > 0 && (
            <span className="pcc-save">{t('feed.promoSave', { n: save })}</span>
          )}
        </div>
        {item.subtitle && <div className="pcc-sub">{item.subtitle}</div>}
      </div>
    </div>
  );
}
